import React, { useEffect, useRef } from "react";

import { Box, Text, Divider } from "@chakra-ui/react";

const Group = ({
  title,
  children,
  mt,
  bgColor,
  py,
  mtDivider,
  dividerFalse,
  marginTitle,
  position,
  regularidade,
  opcoes,
  menuComponent,
  showMenuItemsAtribuicao,
  border,
  scrollToField,
}) => {
  const anexoRef = useRef(null);
  useEffect(() => {
    scrollToField && scrollToField(anexoRef);
  }, [scrollToField]);
  return (
    <Box
      position={position ? position : ""}
      mt={mt ? mt : "15px"}
      display="block"
      px="18px"
      py={py ? py : "25px"}
      pt={!title ? "10px" : "25px"}
      pb={marginTitle && "5px"}
      borderRadius="10px"
      w={"100%"}
      bgColor={bgColor ? bgColor : "#FFF"}
      border={border ? border : ""}
      ref={anexoRef}
    >
      <Text
        fontWeight={700}
        fontSize="16px"
        display={opcoes && "flex"}
        justifyContent={opcoes && "space-between"}
        lineHeight="21.6px"
        color={`${regularidade ? "#169499" : "#169499"}`}
      >
        {title.toUpperCase()}
        {opcoes && showMenuItemsAtribuicao && (
          <Box>
            <Box position="relative" mr={"20px"}>
              <Text as="b" color="black" fontSize={"md"}>
                Opções
              </Text>
              {menuComponent}
            </Box>
          </Box>
        )}
      </Text>

      {!dividerFalse && (
        <Divider
          mt={mtDivider ? mtDivider : "10px"}
          orientation="horizontal"
          borderColor={"#DDEBEA"}
        />
      )}
      {children}
    </Box>
  );
};

export default Group;
